import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col, ListGroup, Card, Image } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetSupplyDetailsQuery } from '../slices/suppliesApiSlice';
import SupplyCarousel from '../components/SupplyCarousel';

const SupplyScreen = () => {
  const { id: supplyId } = useParams();

  const { data: supply, refetch, isLoading, error } = useGetSupplyDetailsQuery(supplyId);

  useEffect(() => {
    if (!supply) {
      refetch();
    }
  }, [supply, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>Supply {supply._id}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h2>Supplier Details</h2>
              <p>
                <strong>Name: </strong> {supply.supplierDetails.name}
              </p>
              <p>
                <strong>Company: </strong> {supply.supplierDetails.company}
              </p>
              <p>
                <strong>Phone: </strong> {supply.supplierDetails.telephone}
              </p>
              <p>
                <strong>Address: </strong> {supply.supplierDetails.address}
              </p>
              <p>
                <strong>Serial: </strong> {supply.supplierDetails.serialNumber}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Supply Note</h2>
              <p>{supply.note || 'No additional notes provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Supply Items</h2>
              {supply.supplyItems.length === 0 ? (
                <Message>This supply has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {supply.supplyItems.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item.images}
                            alt={item.name}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item.name}</strong>
                        </Col>
                        <Col md={4}>
                          {item.qty} x ${item.price} = ${item.qty * item.price}
                        </Col>
                        <Col md={2}>
                          <strong>Cost: </strong>${item.cost}
                        </Col>
                        <Col md={2}>
                          <strong>Profit: </strong>${item.profit}
                        </Col>

                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Supply Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{supply.date.substring(0, 10)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Expiry Date</Col>
                  <Col>{supply.expiryDate.substring(0, 10)}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Total Cost</Col>
                  <Col>${supply.cardCost}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{supply.status}</Col>
                  <Col>{supply?.username || 'No user name provided'}</Col>
                  <Col md={6}>
                            {/* Display expense images using SupplyCarousel */}
                            {supply.images && supply.images.length > 0 ? (
                              <SupplyCarousel images={supply.images} />
                            ) : (
                              <Message variant="info">No images available for this expense</Message>
                            )}
                   </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SupplyScreen;